import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    ChevronRight,
    Accessibility,
    TrendingUp,
    Settings2
} from 'lucide-react';
import './HazardReporting.css';

const HazardReporting = () => {
    useEffect(() => {
        document.title = "Hazard Reporting & Proactive Risk Elimination | X-Max";
        let metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', 'Empower every employee to become a frontline safety advocate with X-Max Hazard Reporting. Mobile-first platform for rapid identification and risk elimination.');
        }
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="hazard-page">
            {/* Hero Section */}
            <section className="hazard-hero">
                <div className="container hazard-hero-container">
                    <div className="hazard-hero-content">
                        <div className="sec-tag">CORE MODULES</div>
                        <h1>Hazard Reporting: <span className="gradient-text">Proactive Risk Elimination</span></h1>
                        <p className="hero-desc">
                            X-Max's Hazard Reporting module empowers every employee to become a frontline safety advocate. By providing an intuitive, mobile-first platform, we enable rapid identification and reporting of potential hazards.
                        </p>
                        <p className="hero-subtext">
                            Ensuring that <span className="highlight-text">risks are addressed proactively</span> before they can lead to incidents. This module fosters a culture of vigilance, continuously improving workplace safety.
                        </p>
                        <Link to="/book-now" className="btn btn-primary btn-lg">
                            Book Demo <ChevronRight size={20} />
                        </Link>
                    </div>
                    <div className="hazard-hero-visual">
                        <div className="visual-wrapper">
                            <img
                                src="./assets/modules/safety.png"
                                alt="Risk Elimination Dashboard"
                                className="hero-img"
                            />
                            <div className="visual-overlay"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Workflow Section */}
            <section className="hazard-workflow">
                <div className="container">
                    <div className="workflow-steps">
                        <div className="workflow-card">
                            <div className="workflow-icon"><Accessibility size={24} /></div>
                            <h3>Identify & Report</h3>
                            <p>Workers can instantly identify and report hazards using the mobile app, capturing details, photos, and precise locations.</p>
                            <div className="workflow-arrow"><ChevronRight size={20} /></div>
                        </div>
                        <div className="workflow-card">
                            <div className="workflow-icon"><TrendingUp size={24} /></div>
                            <h3>Assess & Prioritise</h3>
                            <p>The platform assists in assessing the severity and likelihood of each reported hazard, enabling effective prioritisation using a built-in risk matrix.</p>
                            <div className="workflow-arrow"><ChevronRight size={20} /></div>
                        </div>
                        <div className="workflow-card">
                            <div className="workflow-icon"><Settings2 size={24} /></div>
                            <h3>Action & Verify</h3>
                            <p>Corrective actions are assigned, tracked, and verified to ensure full resolution, systematically eliminating risks and preventing recurrence across the plant.</p>
                        </div>
                    </div>
                    <p className="workflow-footer-text">
                        Our system streamlines the process of <strong>Hazard Reporting</strong>. This critical data is immediately logged and routed for review.
                    </p>
                </div>
            </section>

            {/* Final CTA */}
            <section className="hazard-footer-cta">
                <div className="container">
                    <div className="cta-card">
                        <h2>Ready to eliminate hazards at the source?</h2>
                        <Link to="/book-now" className="btn btn-primary btn-lg">Request a Risk Audit</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HazardReporting;
